import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../api-base-url.token';

export interface AffluenceThresholds {
  waitLowMinutes: number;
  waitHighMinutes: number;
}

export interface EstablishmentAffluenceThresholds {
  thresholds: AffluenceThresholds;
  isOverride: boolean;
}

/**
 * Seuils Fluide / Modéré / Forte affluence (temps d'attente, seul indicateur retenu pour le
 * statut affiché) : défaut au niveau organisation, surchargeable par établissement.
 */
@Injectable({ providedIn: 'root' })
export class AffluenceThresholdsService {
  private http = inject(HttpClient);
  private base = inject(API_BASE_URL).replace(/\/+$/, '');

  private join(path: string): string {
    return `${this.base}${path.startsWith('/') ? '' : '/'}${path}`;
  }

  getOrgDefault(): Observable<AffluenceThresholds> {
    return this.http.get<AffluenceThresholds>(this.join('/api/v1/quality/affluence-thresholds/default'));
  }

  setOrgDefault(thresholds: AffluenceThresholds): Observable<void> {
    return this.http.put<void>(this.join('/api/v1/quality/affluence-thresholds/default'), thresholds);
  }

  getForEstablishment(establishmentId: string): Observable<EstablishmentAffluenceThresholds> {
    return this.http.get<EstablishmentAffluenceThresholds>(
      this.join(`/api/v1/quality/affluence-thresholds/establishments/${establishmentId}`)
    );
  }

  setForEstablishment(establishmentId: string, thresholds: AffluenceThresholds): Observable<void> {
    return this.http.put<void>(
      this.join(`/api/v1/quality/affluence-thresholds/establishments/${establishmentId}`),
      thresholds
    );
  }

  clearForEstablishment(establishmentId: string): Observable<void> {
    return this.http.delete<void>(this.join(`/api/v1/quality/affluence-thresholds/establishments/${establishmentId}`));
  }
}
